const DoubleQuotes = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="43"
      viewBox="0 0 48 43"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.56534 42.334C14.8414 42.334 19.1185 38.057 19.1185 32.7809V26.1606C19.1185 23.7083 17.1305 21.7204 14.6783 21.7204C12.226 21.7204 10.1557 19.7063 10.6777 17.3103C10.9913 15.8709 11.4727 14.5746 12.1218 13.4214C12.9492 11.8928 14.2438 10.616 16.0057 9.59095C17.7703 8.56426 19.1185 6.8283 19.1185 4.78672C19.1185 1.91199 16.5552 -0.349743 13.8797 0.701962C13.0034 1.04645 12.1483 1.44911 11.3145 1.90994C8.98229 3.15925 6.96403 4.7655 5.25971 6.7287C3.5554 8.69191 2.2099 10.9674 1.22319 13.5553C0.326184 16.1431 -0.0774685 18.9095 0.0122319 21.8543V32.7809C0.0122319 38.057 4.2893 42.334 9.56534 42.334ZM38.2247 42.334C43.5007 42.334 47.7778 38.057 47.7778 32.7809V26.1606C47.7778 23.7083 45.7898 21.7204 43.3376 21.7204C40.8854 21.7204 38.815 19.7063 39.337 17.3103C39.6506 15.8709 40.132 14.5746 40.7811 13.4214C41.6085 11.8928 42.9031 10.616 44.665 9.59095C46.4296 8.56427 47.7778 6.8283 47.7778 4.78672C47.7778 1.91199 45.2145 -0.349743 42.5391 0.701962C41.6627 1.04645 40.8076 1.44911 39.9738 1.90994C37.6416 3.15925 35.6234 4.7655 33.919 6.7287C32.2147 8.69191 30.8692 10.9674 29.8825 13.5553C28.9855 16.1431 28.5819 18.9095 28.6716 21.8543V32.7809C28.6716 38.057 32.9486 42.334 38.2247 42.334Z"
        fill="white"
      />
    </svg>
  );
};
export default DoubleQuotes;
